import { AppIcon, RawSVG } from 'core/components/icons/icon.type';

export const iconHeart: AppIcon = {
  svgData: '<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path clip-rule="evenodd" d="M16.679 7.966 16 8.655l-.679-.69a6.585 6.585 0 0 0-9.385 0v0a6.832 6.832 0 0 0 0 9.53l7.19 7.301a4.033 4.033 0 0 0 5.748 0l7.19-7.3a6.832 6.832 0 0 0 0-9.53v0a6.585 6.585 0 0 0-9.385 0Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' as RawSVG,
  name: 'heart',
};
